var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('directory-spots-panel',{attrs:{"tree-node-id":_vm.treeNodeId,"user-id":_vm.userId}})}
var staticRenderFns = []

export { render, staticRenderFns }